import { render, staticRenderFns } from "./InspirationListItemPlaceholder.vue?vue&type=template&id=141c0b9e"
import script from "./InspirationListItemPlaceholder.vue?vue&type=script&lang=js"
export * from "./InspirationListItemPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports